import { render } from "./IdentityView.vue?vue&type=template&id=34bcdb31&scoped=true"
const script = {}

import "./IdentityView.vue?vue&type=style&index=0&id=34bcdb31&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34bcdb31"]])

export default __exports__